import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuienesSomosComponent } from './pages/quienes-somos/quienes-somos.component';
import { SharedModule } from '../../shared/shared.module';
import { SliderMainQuienesComponent } from './components/slider-main-quienes/slider-main-quienes.component';
import { BlockAreaQuienesComponent } from './components/block-area-quienes/block-area-quienes.component';
import { SliderAreaQuienesComponent } from './components/slider-area-quienes/slider-area-quienes.component';
import { PhrasesQuienesComponent } from './components/phrases-quienes/phrases-quienes.component';
import { ParallaxQuienesComponent } from './components/parallax-quienes/parallax-quienes.component';
import { ImgTitleComponent } from './components/img-title/img-title.component';



@NgModule({
  declarations: [
    QuienesSomosComponent,
    SliderMainQuienesComponent,
    BlockAreaQuienesComponent,
    SliderAreaQuienesComponent,
    PhrasesQuienesComponent,
    ParallaxQuienesComponent,
    ImgTitleComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    QuienesSomosComponent
  ]
})
export class QuienesSomosModule { }
